import { Link } from 'react-router-dom';
import { PublicLayout } from '@/components/layout/PublicLayout';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import SEO from '@/components/SEO';

export default function NotFoundPage() {
  return (
    <PublicLayout>
      <SEO
        title="Page introuvable (404)"
        description="Cette page n'existe pas ou a été déplacée. Retournez à l'accueil de Villa Marceau."
        canonical="/"
        noindex={true}
      />
      <div className="flex flex-col items-center justify-center min-h-[60vh] px-6 text-center" data-testid="not-found-page">
        <h1 className="font-heading text-6xl md:text-8xl font-bold text-muted-foreground/30 mb-4">
          404
        </h1>
        <h2 className="font-heading text-2xl md:text-3xl font-semibold mb-4">
          Page introuvable
        </h2>
        <p className="text-muted-foreground text-lg mb-8 max-w-md">
          La page que vous recherchez n'existe pas ou a été déplacée.
        </p>
        <div className="flex flex-col sm:flex-row gap-4">
          <Link to="/" data-testid="back-home-btn">
            <Button className="btn-primary">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Retour à l'accueil
            </Button>
          </Link>
          <Link to="/commander-en-ligne" data-testid="go-shop-btn">
            <Button variant="outline">
              Commander en ligne
            </Button>
          </Link>
        </div>
      </div>
    </PublicLayout>
  );
}
